export const getLuminaryFormData = (data, photos) => {
    const formData: FormData = new FormData();
    const cloneData = JSON.parse(JSON.stringify(data));
    for (let i = 0; i < photos?.length; i++) {
        formData.append(`files[${i}]`, photos[i], '' + new Date().getTime());
    }

    Object.keys(cloneData).forEach(key => {
        if (key === 'photos') {
            cloneData.photos = cloneData.photos?.filter((photo) => !photo.includes('/base64'));
        }
        formData.append(key, typeof cloneData[key] === 'object' ? JSON.stringify(cloneData[key]) : cloneData[key]  );
    });

    return formData;
}
